import { render, staticRenderFns } from "./writeXa.vue?vue&type=template&id=66a5173e&scoped=true"
import script from "./writeXa.vue?vue&type=script&lang=js"
export * from "./writeXa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a5173e",
  null
  
)

export default component.exports